<template>
  <header class="app-header header__shadow">
    <div class="app-header__title">
      <h1>{{ routeLabel }}</h1>
    </div>
    <div class="app-header__tools">
      <HeaderRecapSottoscrizioniPaziente v-if="$root.scope === 'concura'" />
      <a
        :href="publicArea"
        class="app-header__link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b-icon icon="box-arrow-up-right" aria-hidden="true"></b-icon>
        <span class="app-header__link-text">{{ publicArea.replace("https://", "www.") }}</span>
      </a>
      <b-dropdown id="header-lang" variant="white" right class="app-header__menu">
        <template #button-content>
          <b-icon icon="globe2" aria-hidden="true"></b-icon>
          <span class="app-header__menu-text">{{ $t('seleziona_lingua') }}</span>
        </template>
        <b-dropdown-item @click="$store.commit('lang/setLocale', 'it')">🇮🇹 Italiano</b-dropdown-item>
        <b-dropdown-item @click="$store.commit('lang/setLocale', 'en')">🇬🇧 English</b-dropdown-item>
      </b-dropdown>
      <b-dropdown id="header-submenu" variant="white" right class="app-header__menu app-header__user">
        <template #button-content>
          <b-avatar size="sm" variant="secondary" :text="userInitials" aria-hidden="true"></b-avatar>
          <span class="app-header__menu-text" :class="{ 'text-capitalize': hasFullName }">{{ welcomeName }}</span>
        </template>
        <b-dropdown-item @click.prevent="$bvModal.show('logout-confirm')">
          <b-icon icon="door-open" aria-hidden="true" class="mr-2"></b-icon>{{ $t('esci') }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </header>
</template>
<script>
import { mapState } from "vuex";
import { CITTADINO_ROUTE_NAMES } from "@/_utils/constants.js";
import HeaderRecapSottoscrizioniPaziente from "@/app/modules/sottoscrizioni/components/HeaderRecapSottoscrizioniPaziente.vue";

export default {
  name: "CittadinoTopHeader",
  components: {
    HeaderRecapSottoscrizioniPaziente,
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
    // Senza anagrafica il ripiego è lo username, che spesso è un indirizzo di
    // posta: capitalizzarlo lo renderebbe "Mario.Rossi@Mail.Com"
    hasFullName() {
      return !!(this.user && this.user.anagrafica);
    },
    welcomeName() {
      if (this.hasFullName) {
        return `${this.user.anagrafica.name} ${this.user.anagrafica.surname}`;
      }
      return this.user.username;
    },
    // Iniziali per l'avatar nel header (solo presentazione)
    userInitials() {
      return String(this.welcomeName || "")
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((p) => p.charAt(0))
        .join("")
        .toUpperCase();
    },
    routeLabel() {
      try {
        const labelKey = this.routeNames[this.$route.name];

        if (!labelKey) throw "label not found";

        if (this.$route.name === "appuntamenti") {
          const subKey = labelKey[this.$route.params.type];
          return this.$t(subKey);
        }

        if (this.$route.name === "teleconsulti") {
          const subKey = labelKey[this.$route.params.subsection];
          return this.$t(subKey);
        }

        return this.$t(labelKey);
      } catch (err) {
        return `${this.$t('hello')}, ${this.welcomeName}`;
      }
}
  },
  data() {
    return {
      routeNames: CITTADINO_ROUTE_NAMES,
      publicArea: process.env.VUE_APP_PUBLIC_AREA,
    };
  },
};
</script>
